import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';

function Header() {
  const { oktaAuth, authState } = useOktaAuth();

  const logout = async () => {
    if (USE_MOCK) {
      window.location.reload();
      return;
    }
    await oktaAuth.signOut({ postLogoutRedirectUri: 'https://instacart.okta.com' });
  };

  const userEmail = USE_MOCK
    ? 'mock-user@instacart.com'
    : (authState?.idToken?.claims?.email || 'User');

  return (
    <header className="header" role="banner">
      <div className="header-brand">
        <div className="header-logo" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="5" fill="rgba(107, 191, 89, 0.2)" />
            <path
              d="M7 12l4 4 6-7"
              stroke="#6BBF59"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div>
          <h1 className="header-title">Termination Admin</h1>
          <span className="header-subtitle">Queue Management Console</span>
        </div>
      </div>
      <div className="header-right">
        {USE_MOCK && (
          <span className="mock-badge" role="status">Mock</span>
        )}
        <div className="header-user" aria-label={`Signed in as ${userEmail}`}>
          <div className="user-avatar" aria-hidden="true">
            {userEmail.charAt(0).toUpperCase()}
          </div>
          <span className="user-email">{userEmail}</span>
        </div>
        <button
          onClick={logout}
          className="logout-button"
          aria-label={USE_MOCK ? 'Refresh page' : 'Sign out'}
        >
          {USE_MOCK ? 'Refresh' : 'Sign Out'}
        </button>
      </div>
    </header>
  );
}

export default Header;
